import { action } from "@ember/object";
import { oneWay, readOnly } from "@ember/object/computed";
import { classNameBindings, classNames } from "@ember-decorators/component";
import { i18n } from "discourse-i18n";
import DropdownSelectBoxComponent from "select-kit/components/dropdown-select-box";
import { selectKitOptions } from "select-kit/components/select-kit";
const PeriodChooser = dt7948.c(class PeriodChooser extends DropdownSelectBoxComponent {
  static {
    dt7948.g(this.prototype, "content", [oneWay("site.periods")]);
  }
  #content = (dt7948.i(this, "content"), void 0);
  static {
    dt7948.g(this.prototype, "value", [readOnly("period")]);
  }
  #value = (dt7948.i(this, "value"), void 0);
  valueProperty = null;
  nameProperty = null;
  showPeriods = true;
  modifyComponentForRow() {
    return "period-chooser/period-chooser-row";
  }
  _onChange(value) {
    if (this.action) {
      this.action(value);
    } else {
      this.onChange?.(value);
    }
  }
  static {
    dt7948.n(this.prototype, "_onChange", [action]);
  }
}, [selectKitOptions({
  filterable: false,
  autoFilterable: false,
  fullDay: "fullDay",
  customStyle: true,
  headerComponent: "period-chooser/period-chooser-header",
  headerAriaLabel: i18n("period_chooser.aria_label")
}), classNameBindings("showPeriods::hidden"), classNames("period-chooser")]);
export default PeriodChooser;